module.exports = {
  "affiliates.form.phone.errorMessage.invalid": "Ingresa teléfono en formato +571234567890",
  "affiliates.form.phone.assistiveText": "Usa formato +571234567890",
  "affiliates.form.siteUrl.tooltip": "Si quieres compartir el perfil de alguna red social, incluye la URL completa del sitio. Ejemplo:  https://twitter.com/comparaonlineco"
}
